import add from './add'
import card from './card'
import description from './description'
import header from './header'
import inactive from './inactive'
import list from './list'
import microtrends from './microtrends'
import threads from './threads'
import trends from './trends'
import shareActionButton from './share-action-button'

export default {
    add,
    card,
    description,
    header,
    inactive,
    list,
    microtrends,
    shareActionButton,
    threads,
    trends
}
